import { render, staticRenderFns } from "./TheNotificationContainer.vue?vue&type=template&id=74f94954&scoped=true&"
import script from "./TheNotificationContainer.vue?vue&type=script&lang=js&"
export * from "./TheNotificationContainer.vue?vue&type=script&lang=js&"
import style0 from "./TheNotificationContainer.vue?vue&type=style&index=0&id=74f94954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f94954",
  null
  
)

export default component.exports